import { CREATE_OPTION_KEYS, STOREFRONT_ROUTES } from '../constants'

export const getCreateNavigation = (selected: {
  key: string
  route?: string
}) => {
  if (selected.key === CREATE_OPTION_KEYS.NEW_BUTTON) {
    if (selected.route) {
      return {
        path: STOREFRONT_ROUTES.NAVIGATE_BUTTON,
        clearButton: true,
        clearListing: false,
      }
    }
    return null
  }
  if (selected.route) {
    return {
      path: STOREFRONT_ROUTES.NAVIGATE_LISTING_CARD,
      clearButton: false,
      clearListing: true,
    }
  }
  return null
}
